export const data = [
    {
        id: "0",
        question: "What is an extrude?",
        answer: "When a 2d sketch is used to make a 3d object.",
        variants: [`When an existing 3d object is made thicker in a given dimension.`, `The act of making sausages.`, `When a 2d sketch is used to make a 3d object.`, `When a part protrudes out of a box.`]
    },
    {
        id: "1",
        question: "What does 'symmetric' extrude mean?",
        answer: "The sketch extends in both directions relative to the sketch face.",
        variants: [`The sketch extends in both directions relative to the sketch face.`, `When you form an object with at least one line of symmetry.`, `When you form an object with infinite lines of symmetry.`, `When you extrude a sketch profile in all directions.`]
    },
    {
        id: "2",
        question: "What is a 'blind' extrude?",
        answer: "You can specify the distance you want to extrude.",
        variants: [`When an extruded object is so big that you have to zoom out.`, `When the extrude is hidden so you can't see it.`, `The extrude is calculated relative to another object/face.`, `You can specify the distance you want to extrude.`]
    },
]

// {
//     id: "3",
//     question: "",
//     answer: "",
//     variants: [``, ``]
// },